module.exports = __webpack_public_path__ + "media/3.a98a3de4.mp3";